import { render } from "./FormCallBack.vue?vue&type=template&id=7fd8a779"
import script from "./FormCallBack.vue?vue&type=script&lang=js"
export * from "./FormCallBack.vue?vue&type=script&lang=js"

import exportComponent from "/Users/raulbajmuhametov/work/vue/grany/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__